import React, { useState, useEffect } from "react";

const EventDetail = ({ match }) => {
  const idSearch = match.params.id;

  const [event, setEvent] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(`https://revived-witch-api.herokuapp.com/api/events/${idSearch}`);
      res.json().then((res) => setEvent(res.event));
    };

    fetchData();
  }, [idSearch]);
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: event.content }} />
    </>
  );
};

export default EventDetail;
